/* eslint-disable */
import { useEffect, useRef } from 'react'
import { useTrayProducts } from './TrayProduct/TrayProducts.logic'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'

const TrayProductsPassthrough = () => {
  const { handleSubmit } = useTrayProducts()
  const isSubmittedRef = useRef(false)

  useEffect(() => {
    if (!isSubmittedRef.current) {
      handleSubmit()
      isSubmittedRef.current = true
    }
  }, [])

  return (
    <div className="dtm-tray-products_wrapper">
      <LoadingIndicator />
    </div>
  )
}

export default TrayProductsPassthrough
